import { formatDistanceToNowStrict } from 'date-fns';

export const formatInteger = (value: number | null | undefined): string => (typeof value === 'number' ? value.toLocaleString() : '0');

export const formatCount = (value: number | null | undefined, singular: string, plural = `${singular}s`): string =>
  `${formatInteger(value)} ${value === 1 ? singular : plural}`;

export const formatBytes = (value: number | null | undefined): string => {
  if (!value) {
    return '0 B';
  }

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let unitIndex = 0;
  let size = value;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }

  return `${size.toFixed(size >= 10 || unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
};

export const formatDuration = (value: number | null | undefined, unit: string): string => {
  if (typeof value !== 'number') {
    return 'n/a';
  }

  const normalizedUnit = unit.toLowerCase();

  if (normalizedUnit === 'ms' || normalizedUnit === 'milliseconds') {
    if (value >= 60_000) {
      return `${(value / 60_000).toFixed(1)} min`;
    }

    if (value >= 1000) {
      return `${(value / 1000).toFixed(1)} s`;
    }

    return `${value.toLocaleString(undefined, { maximumFractionDigits: 1 })} ms`;
  }

  if (normalizedUnit === 's' || normalizedUnit === 'second' || normalizedUnit === 'seconds') {
    return `${value.toLocaleString(undefined, { maximumFractionDigits: 1 })} s`;
  }

  return `${value.toLocaleString(undefined, { maximumFractionDigits: 1 })} ${unit}`;
};

export const formatTime = (value: string | Date | null | undefined): string => {
  if (!value) {
    return 'n/a';
  }

  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) {
    return 'n/a';
  }

  return date.toLocaleString();
};

export const formatRelativeTime = (value: string | null | undefined): string => {
  if (!value) {
    return 'n/a';
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return 'n/a';
  }

  return `${formatDistanceToNowStrict(date)} ago`;
};
